import request from '@/utils/request'
const apiPath = '/course/courseRecord'
import { downloadBlob } from '@/utils/download'
const courseRecordApi = {
  /**
   * 分页查询【学习统计】
   */
  fetchList(query) {
    return request.get(apiPath+'/getStudyRecordList', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  // 导出【学习统计】excel
  exportExcel(query) {
   return request.get(`${apiPath}/studyRecordListExportExcel`, { params: query })
  },
}
export default courseRecordApi
